import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import moduleReducer from "./moduleSlice";
import pastUploadsReducer from "./pastUploadsSlice";
import selectedDataRecordReducer from "./selectedDataRecordSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    module: moduleReducer,
    pastUploads: pastUploadsReducer,
    selectedDataRecord: selectedDataRecordReducer,
  },
});

export default store;
